// pages/support/knowledge/KnowledgeUpdatePage.tsx
import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import PageListLayout from "../../../../layouts/PageListLayout";
import KnowledgeArticleForm from "../../../../components/features/support/knowledge/KnowledgeArticleForm";
import useKnowledge from "../../../../hooks/support/knowledge/useKnowledge";
import { alertSuccess, alertError } from "../../../../helpers/alertError";

export default function KnowledgeUpdatePage() {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const { getArticle, updateArticle, saving, loading } = useKnowledge();
  const [initialData, setInitialData] = useState<any>(null);

  useEffect(() => {
    if (id) {
      loadArticle();
    }
  }, [id]);

  const loadArticle = async () => {
    const article = await getArticle(id!);
    if (article) {
      setInitialData(article);
    } else {
      alertError("Article non trouvé");
      navigate("/support/knowledge");
    }
  };

  const handleSubmit = async (data: any) => {
    try {
      const result = await updateArticle(id!, data);
      if (result) {
        alertSuccess("Article modifié avec succès");
        navigate("/support/knowledge");
      } else {
        alertError("Erreur lors de la modification");
      }
    } catch (error) {
      alertError("Erreur lors de la modification");
    }
  };

  if (loading) {
    return (
      <PageListLayout title="Modifier l'article">
        <div className="flex justify-center items-center py-12">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-green-600"></div>
        </div>
      </PageListLayout>
    );
  }

  return (
    <PageListLayout title="Modifier l'article">
      <div className="p-6 max-w-4xl mx-auto">
        <KnowledgeArticleForm
          initialData={initialData}
          onSubmit={handleSubmit}
          isLoading={saving}
          onCancel={() => navigate("/support/knowledge")}
        />
      </div>
    </PageListLayout>
  );
}
